module.exports = __webpack_public_path__ + "img/hipercard.b23f0f9.png";